import { titleize } from 'utils/common';
import { CATEGORY } from 'resources/constants';

import { Translate } from 'common/types';

type Text = (path: string, data?: { [key: string]: string | number }) => string;

export function subText(t: Text, data: Translate['data']): string {
  let translateData = {};

  if (data?.category === CATEGORY.transport) {
    translateData = {
      from: titleize(t(`translate.locations.${data.from}`)),
      to: titleize(t(`translate.locations.${data.to}`)),
      actualDistance: data.actualDistance,
    };

    return t(`translate.${data.category}_text.actual_distance`, translateData);
  }

  if (data?.category === CATEGORY.energy) {
    translateData = {
      appliance: t(`translate.appliances.${data.appliance}`),
      quantity: data.quantity,
      units: t(`translate.units.${data.units}`),
      actualKwh: data.actualKwh,
    };

    return t(
      `translate.${data.category}_text.${data.subCategory}.actual_energy_used`,
      translateData
    );
  }

  return '';
}

export function mainText(
  t: Text,
  data?: Translate['data'],
  type?: 'footprint'
): string {
  let translateData = {};

  if (data?.category === CATEGORY.transport) {
    translateData = {
      from: titleize(t(`translate.locations.${data.from}`)),
      to: titleize(t(`translate.locations.${data.to}`)),
      vehicle: t(`translate.vehicles.${data.vehicle}`),
      transportMethod: t(`translate.transport_methods.${data.vehicle}`),
      convertedDistance: data.convertedDistance,
      actualDistance: data.actualDistance,
    };

    if (type === 'footprint') {
      return t(
        `translate.${data.category}_text.footprint_equivalent_to`,
        translateData
      );
    }

    return t(
      `translate.${data.category}_text.saving_equivalent_to`,
      translateData
    );
  }

  if (data?.category === CATEGORY.energy) {
    translateData = {
      appliance: t(`translate.appliances.${data.appliance}`),
      quantity: data.quantity,
      units: t(`translate.units.${data.units}`),
      convertedKwh: data.convertedKwh,
    };

    if (type === 'footprint') {
      return t(
        `translate.${data.category}_text.${
          data.subCategory
        }.footprint_equivalent_to${
          data.units === 'times' ? `_${data.units}` : ``
        }`,
        translateData
      );
    }

    return t(
      `translate.${data.category}_text.${
        data.subCategory
      }.saving_equivalent_to${data.units === 'times' ? `_${data.units}` : ``}`,
      translateData
    );
  }

  return '';
}

type Type = 'averageFootprint' | 'potential_savings' | 'footprint';

export function title(
  t: Text,
  co2: number,
  type?: Type,
  sectionName?: string
): string {
  if (type === 'averageFootprint') {
    return t('translate.average_co2_footprint', {
      co2,
      sectionName,
    });
  }

  if (type === 'footprint') {
    return t('translate.total_co2_footprint', {
      co2,
    });
  }

  if (type === 'potential_savings') {
    return t('translate.total_co2_potential_saving', {
      co2,
    });
  }

  return t('translate.total_co2_saved', {
    co2,
  });
}
